import { type FC, useState } from 'react';
import { SmilePlus } from 'lucide-react';
import {
  EmojiPicker as FrimousseEmojiPicker,
  EmojiPickerContent as FrimousseEmojiPickerContent,
  EmojiPickerFooter as FrimousseEmojiPickerFooter,
  EmojiPickerSearch as FrimousseEmojiPickerSearch,
} from '@/components/ui/emoji-picker';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { useTranslations } from 'next-intl';

export const EmojiPickerComponent: FC<{
  onEmojiSelect: (emoji: string) => void;
  disabled?: boolean;
}> = ({ onEmojiSelect, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const tEmojiPicker = useTranslations('emojiPicker');

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen}>
      <PopoverTrigger asChild>
        <span className="inline-flex">
          <Button
            icon={SmilePlus}
            aria-label={tEmojiPicker('triggerTooltip')}
            variant="main-toolbar"
            size="main-toolbar"
            className="-ml-2 rounded-full p-0"
            iconClassName="icon-5"
            tooltip={tEmojiPicker('triggerTooltip')}
            disabled={disabled}
            data-cy="emoji-picker-trigger"
          />
        </span>
      </PopoverTrigger>
      <PopoverContent className="w-fit p-0">
        <FrimousseEmojiPicker
          className="h-85.5"
          onEmojiSelect={({ emoji }) => {
            onEmojiSelect(emoji);
            setIsOpen(false);
          }}
        >
          <FrimousseEmojiPickerSearch />
          <FrimousseEmojiPickerContent />
          <FrimousseEmojiPickerFooter />
        </FrimousseEmojiPicker>
      </PopoverContent>
    </Popover>
  );
};
